import {
  AccountingVendorPageDocument,
  PayrollConceptPageDocument,
  UpsertLedgerAccountResourceDocument,
  UpsertLedgerAccountResourceMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpsertLedgerAccountResource = () => {
  const [upsertLedgerAccountResource, { loading }] = useMutation(
    UpsertLedgerAccountResourceDocument,
    {
      extractorFn: (data) => data.financeMutations.upsertFinanceLedgerAccountResource,
      refetchQueries: [AccountingVendorPageDocument, PayrollConceptPageDocument],
      awaitRefetchQueries: true,
    }
  )

  return {
    loading,
    upsertLedgerAccountResource: (variables: UpsertLedgerAccountResourceMutationVariables) =>
      upsertLedgerAccountResource({ variables }),
  }
}
